<template>
  <section
    class="lm_swatches_block"
    :style="{
      'background-color': backgroundColor,
      'padding-top': `${ space }px`,
      'padding-bottom': `${ space }px`
    }"
  >
    <slot></slot>
  </section>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    space: {
      type: Number,
      default: 35
    }
  }
}
</script>
